module.exports = __webpack_public_path__ + "img/page.144344c6.png";